import { SelectOption } from './SelectOption.model';

export interface EditSelectOption {
  key: string;
  options: SelectOption[];
}
